import {Spell} from "@/spells/model/Spell.ts";
import {getSchoolAttributes} from "@/spells/model/SpellSchools.ts";
import MarkdownContent from "@/components/markdown/MarkdownContent.tsx";
import DetailPortrait from "@/components/details/DetailPortrait.tsx";
import DetailSection from "@/components/details/DetailSection.tsx";
import {HorizontalLine} from "@/components/HorizontalLine.tsx";
import SpellDetailsHeader from "@/spells/details/SpellDetailsHeader.tsx";
import SpellFacts from "@/spells/details/SpellFacts.tsx";
import {cn} from "@/lib/utils.ts";

export default function SpellDetails({spell}: {spell: Spell}) {
    const school = getSchoolAttributes(spell);

    return (
        <article className={cn(
            "@container overflow-hidden rounded-xl border bg-linear-to-br from-surface-raised to-surface text-sm text-foreground shadow-xl shadow-black/25",
            school.border,
        )}>
            <SpellDetailsHeader spell={spell}/>

            <div className={cn(
                "grid",
                spell.image && "@min-[48rem]:grid-cols-[minmax(0,2fr)_minmax(13rem,1fr)]",
            )}>
                {spell.image &&
                    <DetailPortrait image={spell.image} alt={`Illustration zu ${spell.name}`}/>}
                <div className="min-w-0 @min-[48rem]:col-start-1 @min-[48rem]:row-start-1">
                    <SpellFacts spell={spell}/>
                    <DetailSection title="Beschreibung">
                        <HorizontalLine/>
                        <MarkdownContent markdown={spell.description}
                                         className="pt-2 text-sm leading-relaxed [&_p]:mb-1.5 [&_ul]:my-1.5"/>
                    </DetailSection>
                </div>
            </div>

        </article>
    );
}
